// DEPLOY: /var/www/woody.wtf/frontend/src/components/ReactionTag.js
// The Logic Tree's call for an announcement (market.announcement_reactions, written by the jobs'
// reaction.py right after the AI summary - stage 2 of the rating), as on the Discord alerts:
// "▲ 44% ▼ 26%" = a 44% chance of a 5%+ rise and a 26% chance of a 5%+ fall (calibrated chances:
// an average announcement is about 10 each). Either side at HOT or more stands out in its colour.
// Shown before the AI's own tags on the Company, Announcements, AI Audit and Discord Bot pages,
// styled like NoveltyTag. Renders nothing for announcements not scored (model null).
import React from 'react';

const HOT = 30;                          // ~3x the usual chance of a 5%+ move
const base = {
  display: 'inline-block', marginLeft: '6px', verticalAlign: 'middle', whiteSpace: 'nowrap',
  fontFamily: "'DM Mono', monospace", fontSize: '9px', letterSpacing: '0.06em', lineHeight: 1.4,
  padding: '0 5px', borderRadius: 'var(--radius)', border: '1px solid var(--border)', color: 'var(--text-muted)',
};

export default function ReactionTag({ model }) {
  if (!model || model.alert == null) return null;
  const { reaction, band, alert, risk } = model;
  const hot = Math.max(alert, risk) >= HOT;
  const colour = !hot ? {} : alert >= risk ? { color: '#166534', borderColor: '#166534' } : { color: '#991B1B', borderColor: '#991B1B' };
  const size = reaction && reaction !== 'flat' && band ? ` Most likely ${reaction === 'up' ? 'up' : 'down'} ${band}%.` : '';
  return (
    <span style={{ ...base, ...colour, ...(hot ? { fontWeight: 600 } : {}) }}
          title={`Logic Tree: ${alert}% chance of a 5%+ rise, ${risk}% chance of a 5%+ fall (an average announcement is about 10 each).${size}`}>
      ▲ {alert}% ▼ {risk}%
    </span>
  );
}
